import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { LenderUserCallState } from 'app/models/dto/lender-user-call-state';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class AdminPhoneToolsService {

    constructor(
        private http: ApiHttpClient
    ) {}

    getTeamActiveCalls(): Observable<LenderUserCallState[]> {
        return this.http.get<LenderUserCallState[]>('/phone/admin/get-call-states-for-admin');
    }

}
